function getInitialScale(): number {
    try {
        // Only apply saved scale on touch/mobile devices where CSS scale transform is active
        const isTouch = 'ontouchstart' in window;
        const hasNoHover = window.matchMedia?.('(hover: none)')?.matches ?? false;
        if (!isTouch && !hasNoHover) {
            return 1;
        }

        const saved = localStorage.getItem('app-zoom-scale');
        if (saved) {
            const parsed = parseFloat(saved);
            if (!isNaN(parsed) && parsed > 0 && parsed <= 1.0) {
                return parsed;
            }
        }
    } catch (e) {
        // Ignore localStorage / matchMedia errors
    }
    return 1;
}

/**
 * Shared reactive scale value (singleton).
 * Initialized from localStorage on mobile/touch devices; 1 on desktop.
 * Updated by usePinchZoom when the user pinch-zooms.
 */
const initialScale = getInitialScale();
export const appScale = ref(initialScale);

function shouldApplyCssScale(): boolean {
    if (typeof window === 'undefined') return false;
    const isTouch = 'ontouchstart' in window;
    const hasNoHover = window.matchMedia?.('(hover: none)')?.matches ?? false;
    return isTouch || hasNoHover;
}

function syncCssScale(value: number) {
    if (!shouldApplyCssScale()) return;
    document.documentElement.style.setProperty('--app-scale', value.toString());
}

if (typeof document !== 'undefined') {
    syncCssScale(initialScale);
}

export function setAppScale(value: number) {
    appScale.value = value;
    syncCssScale(value);
}
